/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { formatNumberInThousand, capitalizeFirstLetter } from 'src/helpers';
import { formatFilterOptionValue } from 'src/helpers/analytics-helpers';

import Percent from 'src/components/views/analytics/percent';
import { APP_LANGUAGE_ENGLISH_VALUE } from 'src/constants/language-setting';

type Props = WithI18nProps;
// DONE
class Compact extends Component<Props> {
  renderSubject = (value, index) => {
    const { type, moneyFormat, appLanguage, i18n } = this.props;
    const numberRange = index + 1;
    switch (type) {
      case 'searchTerm':
        return (
          <div>
            <span className="range">{numberRange}.</span>
            <div className="options">
              <div className="option">{value}</div>
            </div>
          </div>
        );

      case 'filterOptions':
        return (
          <div>
            <span className="range">{numberRange}.</span>
            <div className="options">
              {value.map((filterOption, filterOptionIndex) => {
                return (
                  <div className="option" key={filterOptionIndex}>
                    {capitalizeFirstLetter(filterOption.key, appLanguage)}
                    <span
                      className="item-value"
                      dangerouslySetInnerHTML={{
                        __html: formatFilterOptionValue(filterOption, moneyFormat, i18n)
                      }}></span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      default:
        return '';
    }
  };

  render() {
    const { listData, compare, collectionLabel, type } = this.props;
    return (
      <div className="content content-compact">
        {collectionLabel ? (
          <div className="content-compact-title">
            <span>{collectionLabel}</span>
          </div>
        ) : (
          ''
        )}
        <div className="content-compact-content">
          <table className="Polaris-DataTable__Table">
            <tbody>
              {listData.map((item, index) => (
                <tr key={index}>
                  <td className="item-first-col">{this.renderSubject(item[type], index)}</td>
                  {compare ? (
                    <td className="item-percentage">
                      <Percent percent={item.percentChange} />
                    </td>
                  ) : (
                    <td></td>
                  )}
                  <td className="item-total">
                    <TextStyle>{formatNumberInThousand(item.total)}</TextStyle>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  appLanguage: _.get(state.oauth.tenantApp, 'appLanguage', APP_LANGUAGE_ENGLISH_VALUE)
});

export default connect(mapStateToProps)(withI18n()(Compact));
